var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('abbr',{staticClass:"ct-icon",attrs:{"title":_vm.label}},[_c('span',{staticClass:"icon",style:({
      '--background': _vm.color,
      '--backgroundHover': _vm.colorHover || _vm.color,
      '--size': (_vm.size + "rem"),
      maskImage: 'url(' + require(("~/assets/icons/" + _vm.icon + ".svg")) + ')',
    }),attrs:{"aria-label":_vm.label}})])}
var staticRenderFns = []

export { render, staticRenderFns }